import React from 'react';
import {
  Card,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import QRCode from 'react-qr-code';
import arcelik from 'src/assets/images/arcelik.svg';
import beko from 'src/assets/images/beko.svg';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},  
  pcServiceItem: {
    display: 'block',
    color: '#222222',
    textAlign: 'center',
    padding: 2,
    backgroundColor: '#fe9e24',
  },
  pcServiceItemT: {
    fontSize: 10,
    marginBottom: 3,
  },
  pcServiceItemV: {
    fontSize: 7,
  },
  items: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  item: {
    marginRight: 10,
    width: '30%',
  },
  pcCard: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#efefef',
  },
  pcImg: {
    paddingTop: '100%',
    position: 'relative',
    '& img': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      margin: 'auto',
      inset: 0,
      objectFit: 'cover',
    },
  },
  pcContent: {
    position: 'relative',
    padding: '26px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  pcLeftT: {
    fontSize: '18px',
    fontWeight: 500,
    marginBottom: '3px',
  },
  pcLeftV: {
    fontSize: '12px',
    lineHeight: 1.3,
  },
  pcRight: {
    marginTop: '-4rem',
    textAlign: 'center',
  },
  pcQr: {
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    width: '6rem',
    height: '6rem',
  },
  pcRightT: {
    fontSize: '15px',
  },
  cardContent: {
    border: '2px solid #ccc',
    borderRadius: 8,
    padding: theme.spacing(2),
  },
}));
function PersonalDigitalCard() {

  const classes = useStyles();
  const SessionUser = getUser();

  const capitalizeFirstLetter = (wordsString) => {
    const wordsArray = wordsString.split(" ");
    return wordsArray.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
  }


  const user = {
    name: capitalizeFirstLetter(SessionUser.FirstName) + " " + capitalizeFirstLetter(SessionUser.LastName),
    bio: SessionUser.ServiceShopCode + " " + capitalizeFirstLetter(SessionUser.ServiceShopName),
    avatar: localStorage.getItem('UserPhoto'),
    connectedStatus: 'not_connected',
    Message: SessionUser.Message,
    TechnicianCode: SessionUser.TechnicianCode
  };  
  return (    
      <Card variant="outlined">
        <CardContent>
        <div style={{ display: "flex", justifyContent: "center" }}>
        <CardContent>
          <div className={classes.items}>
            <img src={arcelik} alt="Arçelik" className={classes.item} />
            <div className={`${classes.pcServiceItem} ${classes.item}`}>
              <Typography variant="h5">
                Yetkili<br />Servis
              </Typography>
              <Typography variant="h6" style={{fontSize: 10}}>
                0850 210 0 888  
              </Typography>
            </div>
            <img src={beko} alt="Beko" className={classes.item}></img>
          </div>
        </CardContent>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
        <CardContent style={{ textAlign: 'center' }}>
          <div className={classes.pcImg}>
            <img src={user.avatar} alt="Personel" />
          </div>
          <div className={classes.pcContent}>
            <div>
              <Typography variant="h6" className={classes.pcLeftT}>
                {user.name}
              </Typography>
              <Typography variant="body1" className={classes.pcLeftV}>
                Teknisyen<br />
                {user.TechnicianCode}
              </Typography>
            </div>
            <div className={classes.pcRight}>
              <div className={classes.pcQr}>
                <QRCode value={user.name + '-' + user.bio} size={80}/>
              </div>
              <Typography variant="h6" className={classes.pcRightT}>
                {user.bio}
              </Typography>
            </div>
          </div>
        </CardContent>
        </div>
        </CardContent>
      </Card>      
  )
}

export default PersonalDigitalCard;
